import dynamic from 'next/dynamic';
export { default as ContentsRelated } from './components/ContentsRelated';
export { default as ContentMeta } from './components/ContentMeta';
export { default as ContentSocial } from './components/ContentSocial';
export { default as ContentTagsDetail } from './components/ContentTags';
export { default as ContentTopTagsDetail } from './components/ContentTopTags';
export { default as ContentSource } from './components/ContentSource';
export { default as ContentBody } from './components/ContentBody';
export { default as ContentMain } from './components/ContentMain';
export { default as ContentsHistory } from './components/ContentHistory';
export { default as EventSoccer } from './components/EventSoccer';
const AudioSpeech = dynamic(() => import('./components/AudioSpeech'), {
    ssr: false,
});

export { AudioSpeech };
